<script>
    import { format } from "svelte-i18n";

    let { vulnerability, language = "es", show_title = false } = $props();
    const md = new window.markdownit({ html: false });
</script>

<div class="card-body">
    <div>
        {#if vulnerability.cwe}
            <div class="mt-3">
                <span
                    ><strong>{$format("type")}</strong>: {vulnerability.cwe_id}
                    {vulnerability.cwe.name_es || vulnerability.cwe.name}</span
                >
            </div>
        {/if}
        {#if (vulnerability.title_es || vulnerability.title || vulnerability.id) && show_title}
            {#if language == "es"}
                <div class="mt-3">
                    <strong>Título</strong>:
                    <span class="vul-title"
                        >{vulnerability.title_es ||
                            vulnerability.title ||
                            vulnerability.id}</span
                    >
                </div>
            {/if}
            {#if language == "en"}
                <div class="mt-3">
                    <strong>Title</strong>:
                    <span class="vul-title"
                        >{vulnerability.title || vulnerability.id}</span
                    >
                </div>
            {/if}
        {/if}
        {#if vulnerability.summary_es || vulnerability.summary || ""}
            {#if language == "es"}
                <div class="mt-3">
                    <strong>{$format("form.fields.description")}</strong>:
                    <span class="vul-summary"
                        >{@html vulnerability.summary_es
                            ? md.render(vulnerability.summary_es)
                            : md.render(
                                  vulnerability.summary ||
                                      "Description not available",
                              )}</span
                    >
                </div>
            {/if}
            {#if language == "en"}
                <div class="mt-3">
                    <strong>{$format("form.fields.description")}</strong>:
                    <span class="vul-summary"
                        >{@html md.render(
                            vulnerability.summary ||
                                "Description not available",
                        )}</span
                    >
                </div>
            {/if}
        {/if}

        {#if (vulnerability.epss && vulnerability.epss > 0.5) || vulnerability.cisa_added_at}
            <div class="mt-3">
                <i
                    class="fas fa-exclamation-triangle"
                    title="Posibilidad de Explotación Alta"
                ></i>
                <span
                    >{$format(
                        "vulnerability.warnings.high_exploit_chance",
                    )}</span
                >
            </div>
        {/if}

        {#if vulnerability.has_exploit}
            <div class="mt-3">
                <i class="fas fa-bomb" title="Exploit Disponible"></i>
                <span>{$format("vulnerability.warnings.has_exploit")}</span>
            </div>
        {/if}

        {#if vulnerability.seen_wild || vulnerability.cisa_added_at}
            <div class="mt-3">
                <i class="fas fa-biohazard" title="Vista en uso por atacantes"
                ></i>
                <span>{$format("vulnerability.warnings.seen_wild")}</span>
            </div>
        {/if}

        {#if vulnerability.cisa_added_at}
            <div class="mt-3">
                <i class="fas fa-radiation" title="Presente en CISA KEV"></i>
                <span>{@html $format("vulnerability.warnings.cisa_kev")}</span>
            </div>
        {/if}
    </div>
</div>
<!-- /card-body -->

<style>
    .d-flex > * {
        flex: 1;
    }
    .flex-container-2item div:first-child {
        flex: 2;
    }
    .card + .card {
        margin-left: 14px;
    }
    .references-list {
        line-height: 1.5;
    }
    h4 small {
        font-size: 0.75rem;
        display: block;
    }

    .vul-summary {
        /*white-space: break-spaces;*/
        line-height: 1.5;
    }
</style>
